import React from "react";
import SignupStyles from "../../Styles/SignUp/signUp.module.css";
import Form from "./SignUpForm";

const Signup = () => {
  const { container, heading } = SignupStyles;
  return (
    <div className={`container ${container}`}>
      <div className={`text-uppercase ${heading}`}>
        <h1>sign up</h1>
      </div>
      <Form />
    </div>
  );
};

export default Signup;
